import SubCategoryScoreCard from "./SubCategoryScoreCard";
import { Dispatch } from "react";
import { Score, SubCategory } from "../../types";

interface CategoryScoreCardProps {
  category_id: number;
  category_name: string;
  max_scores: number;
  scores: Score[];
  subcategories: SubCategory[];
  handleCommentChange: (categoryId: number, newComment: string) => void;
  setScoreCard: Dispatch<any>;
  scoreCard: {};
  scoreStoragekey: string;
  scorePageState: string;
  currentRole: number;
  isPageViewOnly: boolean;
}

const CategoryScoreCard: React.FC<CategoryScoreCardProps> = ({
  category_id,
  category_name,
  max_scores,
  scores,
  subcategories,
  handleCommentChange,
  setScoreCard,
  scoreCard,
  scoreStoragekey,
  scorePageState,
  currentRole,
  isPageViewOnly,
}) => {
  return (
    <div className="w-layout-blockcontainer twd-form w-container">
      <div className="div-block-3">
        <h1 className="judging-section-title">{category_name}</h1>
        <h1 className="judging-section-title">
          {scores[0]?.category_total_scores || 0}/{max_scores}
        </h1>
      </div>
      <div className="div-block-7">
        <div className="div-block-6">
          {subcategories.map((sc: SubCategory) => (
            <SubCategoryScoreCard
              subCategoryName={sc.subcategory_name}
              setScoreCard={setScoreCard}
              scoreCard={scoreCard}
              scoreStoragekey={scoreStoragekey}
              scorePageState={scorePageState}
              currentRole={currentRole}
              categoryId={category_id}
              subCategoryId={sc.id}
              previousScore={
                sc.subScores.length > 0 ? sc.subScores[0]?.score : null
              }
              subCategoryDesc={sc.description}
              isPageViewOnly={isPageViewOnly}
              key={sc.id}
            />
          ))}
        </div>
        
        <div className="div-block-8">
          { (category_id == 1 || category_id == 6) ? (
          <div className="form-block w-form h-full">
            <form
              id="email-form"
              name="email-form"
              data-name="Email Form"
              method="get"
              data-wf-page-id="66db79b396f7ee0838e776aa"
              data-wf-element-id="8ce65b7d-befd-f460-5b55-7af9d4c69b0e"
              className="h-full"
            >
              <textarea
                placeholder="Enter Comments"
                maxLength={5000}
                id="field-5"
                name="field-5"
                data-name="Field 5"
                className="textarea w-input score__comment"
                defaultValue={
                  scores.length > 0 ? scores[0].category_comment : ""
                }
                onChange={(e) =>
                  handleCommentChange(category_id, e.target.value)
                }
                readOnly={isPageViewOnly}
              ></textarea>
            </form>
          </div>
          ) : ('') }
        </div>
        
      </div>
    </div>
  );
};

export default CategoryScoreCard;
